import clsx from 'clsx';
import React, { useContext, useEffect, useState } from 'react';
import { SelectedAccountContext } from 'src/app/app/(user-pages)/(accounts)/account/[accountId]/AccountClientLayout';
import { InfoCircle } from 'src/app/app/icons/InfoCircle';
import { useUpdateAccountMutation } from 'src/utils/react-query-hooks';
const Tooltip = React.lazy(() => import('@/components/presentational/tailwind/TooltipWrapper'));

export const interests = [
  { label: 'All interests', emoji: '🌎', checked: true, all: true },
  { label: 'Travel', emoji: '🌍', checked: false },
  { label: 'Fitness', emoji: '💪', checked: false },
  { label: 'Food', emoji: '🍔', checked: false },
  { label: 'Fashion', emoji: '👗', checked: false },
  { label: 'Beauty', emoji: '💄', checked: false },
  { label: 'Pets', emoji: '🐶', checked: false },
  { label: 'Art', emoji: '🎨', checked: false },
  { label: 'Photography', emoji: '📷', checked: false },
  { label: 'Music', emoji: '🎵', checked: false },
  { label: 'Sports', emoji: '⚽', checked: false },
  { label: 'Gaming', emoji: '🎮', checked: false },
  { label: 'Technology', emoji: '🖥️', checked: false },
  { label: 'Business', emoji: '💼', checked: false },
  { label: 'Real Estate', emoji: '🏡', checked: false },
  { label: 'Home decor', emoji: '🏠', checked: false },
  { label: 'Education', emoji: '🎓', checked: false },
  { label: 'Personal development', emoji: '🌱', checked: false },
  { label: 'Health & Wellness', emoji: '💊', checked: false },
  { label: 'Memes/humor', emoji: '😂', checked: false },
  { label: 'Nature', emoji: '🌳', checked: false },
  { label: 'Cars', emoji: '🚗', checked: false },
  { label: 'Books', emoji: '📚', checked: false },
  { label: 'Movies/TV', emoji: '🎬', checked: false },
  { label: 'Writing', emoji: '✍️', checked: false },
  { label: 'News', emoji: '📰', checked: false },
  { label: 'Science', emoji: '🔬', checked: false },
  { label: 'Politics', emoji: '🗳️', checked: false },
  { label: 'History', emoji: '📜', checked: false },
]
export const IGInterestOptions = React.memo(() => {

  const { account, setAccountContext } = useContext(SelectedAccountContext);
  const { mutate: mutateAccount, isLoading: isLoadingAccountUpdate } = useUpdateAccountMutation({ accountId: account?.id, hideToast: false });
  const [selectedInterests, setSelectedInterests] = useState<string[]>(account.targeting_options['interests']);
  useEffect(() => {
    setSelectedInterests(account.targeting_options['interests']);
  }, [account]);

  const [checkboxes, setCheckboxes] = useState(() => {
    const updatedInterests = interests.map(lang => ({
      ...lang,
      checked: selectedInterests && Array.isArray(selectedInterests) && selectedInterests.includes(lang.label.toLowerCase())
    }));
    return updatedInterests;
  });

  const handleCheckboxChange = (index) => {
    const updatedCheckboxes = [...checkboxes];
    if (updatedCheckboxes[index].all) { // If "All" option is checked

      // If "All" option is checked and no other option is checked, do nothing
      if (updatedCheckboxes[index].checked === true && updatedCheckboxes.every(checkbox => checkbox.checked === false || checkbox.all === true))
        return
      updatedCheckboxes.forEach((checkbox, i) => { // Uncheck all other options
        if (!checkbox.all)
          checkbox.checked = false;
      });
      // Toggle "All" option
      updatedCheckboxes[index].checked = !updatedCheckboxes[index].checked;

    } else { // If any other option is checked
      updatedCheckboxes[index].checked = !updatedCheckboxes[index].checked;
      if (!updatedCheckboxes.some(checkbox => checkbox.checked && !checkbox.all))
        // Check "All" option if no checkbox is selected
        updatedCheckboxes[0].checked = true;
      else
        updatedCheckboxes[0].checked = false; // Uncheck "All" option
    }
    setCheckboxes(updatedCheckboxes);

    const activeInterests = updatedCheckboxes.filter(checkbox => checkbox.checked).map(checkbox => checkbox.label.toLocaleLowerCase())
    console.log(activeInterests)
    mutateAccount({
      targeting_options: {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore:next-line
        ...account.targeting_options,
        interests: activeInterests,
      }
    }, {
      onSuccess: (data) => {
        if (data)
          setAccountContext(data);
      }
    }); 
  };

  return (
    <>
      <React.Suspense fallback={<CardHeaderTitle />}>
        <Tooltip className="absolute left-10 ml-1 max-w-[300px] shadow-xl"
          content={"Choose the interests you want to target in your audience. Keesy uses AI to identify these interests through users' bios and posts."}
          placement="auto"
          animation="duration-300">
          <CardHeaderTitle />
        </Tooltip>
      </React.Suspense>
      <div className="flex flex-wrap justify-start gap-2 mt-1 mb-2">
        {checkboxes.map((checkbox, index) => (
          <button
            key={index}
            onClick={() => handleCheckboxChange(index)}
            className={clsx(
              "relative inline-flex items-center justify-center p-0.5 my-1 mx-0.5 text-sm font-medium cursor-pointer rounded-[10px] transition-all duration-300 overflow-hidden",
              checkbox.checked
                ? 'text-neutral-700 animate-sway-instantly'
                : 'text-neutral-700 hover:text-neutral-900 bg-white hover:bg-neutral-100 transition-all',
            )}
            style={checkbox.checked ? {} : { boxShadow: '0px 0px 0px 1px rgba(225, 226, 228, 0.56)' }}
          >
            {checkbox.checked && (
              <span className="absolute animate-fade-in duration-300 inset-0 bg-gradient-to-r from-[#7549F4] to-[#FCA6E9] rounded-[10px]"></span>
            )}
            <span className="relative px-3 py-2 overflow-hidden whitespace-nowrap rounded-[8px]"
              style={checkbox.checked ? { background: 'linear-gradient(135deg, #f6f3fd 0%, #fdf7fd 100%), linear-gradient(180deg, rgb(255, 255, 255, 0.16) 0%, rgb(255, 255, 255, 0) 100%)' } : {}}>
              <span className='mr-2'>{checkbox.emoji}</span>
              {checkbox.label}
            </span>
          </button>
        ))}
      </div>
    </>
  );
});

const CardHeaderTitle = () => (
  <div className="flex items-center gap-2 mb-4">
    <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99413 4.27985C8.328 2.332 5.54963 1.80804 3.46208 3.59168C1.37454 5.37532 1.08064 8.35748 2.72 10.467C4.08302 12.2209 8.20798 15.9201 9.55992 17.1174C9.71117 17.2513 9.7868 17.3183 9.87502 17.3446C9.95201 17.3676 10.0363 17.3676 10.1132 17.3446C10.2015 17.3183 10.2771 17.2513 10.4283 17.1174C11.7803 15.9201 15.9052 12.2209 17.2683 10.467C18.9076 8.35748 18.6496 5.35656 16.5262 3.59168C14.4028 1.8268 11.6603 2.332 9.99413 4.27985Z" stroke="url(#paint0_linear_2513_3249)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99413 4.27985C8.328 2.332 5.54963 1.80804 3.46208 3.59168C1.37454 5.37532 1.08064 8.35748 2.72 10.467C4.08302 12.2209 8.20798 15.9201 9.55992 17.1174C9.71117 17.2513 9.7868 17.3183 9.87502 17.3446C9.95201 17.3676 10.0363 17.3676 10.1132 17.3446C10.2015 17.3183 10.2771 17.2513 10.4283 17.1174C11.7803 15.9201 15.9052 12.2209 17.2683 10.467C18.9076 8.35748 18.6496 5.35656 16.5262 3.59168C14.4028 1.8268 11.6603 2.332 9.99413 4.27985Z" stroke="url(#paint1_linear_2513_3249)" strokeOpacity="0.16" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_2513_3249" x1="-5.94654" y1="10.145" x2="8.3928" y2="26.2257" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7549F4" />
          <stop offset="1" stopColor="#FCA6E9" />
        </linearGradient>
        <linearGradient id="paint1_linear_2513_3249" x1="9.99984" y1="2.5" x2="9.99984" y2="17.3618" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
    <div className='inline-flex flex-row items-center'>
      <div className="inline-flex items-center text-base font-medium leading-normal text-zinc-900">
        Followers Interest
        <InfoCircle className="w-5 h-5 ml-2 text-gray-400 place-self-center ignore" />
      </div>
    </div>
  </div>
)